var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.5C6.48072 2.5 2 6.98071 2 12.5C2 18.0193 6.48072 22.5 12 22.5C17.5193 22.5 22 18.0193 22 12.5C22 6.98071 17.5193 2.5 12 2.5ZM12 3.3547C17.0474 3.3547 21.1452 7.4525 21.1452 12.4999C21.1452 17.5473 17.0474 21.6451 12 21.6451C6.9526 21.6451 2.85479 17.5473 2.85479 12.4999C2.85479 7.4525 6.9526 3.3547 12 3.3547Z",
    fill: "#979797",
    stroke: "#979797",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.995 2.5C10.8138 2.5 9.70135 3.23603 8.81593 4.5345C7.59014 6.33207 6.78125 9.22982 6.78125 12.5C6.78125 15.7702 7.59014 18.6679 8.81593 20.4655C9.70139 21.764 10.8138 22.5 11.995 22.5C13.1761 22.5 14.2885 21.764 15.174 20.4655C16.3998 18.6679 17.2087 15.7702 17.2087 12.5C17.2087 9.22982 16.3998 6.33214 15.174 4.5345C14.2885 3.236 13.1761 2.5 11.995 2.5ZM11.995 3.3547C12.9273 3.3547 13.7689 3.9913 14.4678 5.01623C15.6186 6.70376 16.354 9.43021 16.354 12.5C16.354 15.5698 15.6187 18.2963 14.4678 19.9838C13.769 21.0087 12.9273 21.6453 11.995 21.6453C11.0626 21.6453 10.221 21.0087 9.52212 19.9838C8.37134 18.2963 7.63586 15.5698 7.63586 12.5C7.63586 9.43021 8.37125 6.70374 9.52212 5.01623C10.2209 3.9913 11.0626 3.3547 11.995 3.3547Z",
    fill: "#979797",
    stroke: "#979797",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.13276 17.7037C3.97652 17.8693 3.96035 18.1361 4.09527 18.3229C5.93449 20.8654 8.79431 22.5 12.0039 22.5C15.2135 22.5 18.0735 20.8655 19.9126 18.3229C20.0475 18.1361 20.0313 17.8693 19.8751 17.7037C18.0439 15.7596 15.1997 14.5 12.004 14.5C8.80829 14.5 5.96403 15.7595 4.13287 17.7037H4.13276ZM5.02002 18.0788C6.71323 16.452 9.21673 15.4303 12.004 15.4303C14.7913 15.4303 17.2948 16.4521 18.988 18.0788C17.3028 20.2145 14.7981 21.5697 12.004 21.5697C9.20995 21.5697 6.70541 20.2145 5.02002 18.0788Z",
    fill: "#979797",
    stroke: "#979797",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.09527 6.67713C3.96035 6.86387 3.97652 7.13068 4.13276 7.29627C5.96397 9.24044 8.80821 10.5 12.0039 10.5C15.1996 10.5 18.0439 9.24048 19.8751 7.29627C20.0313 7.13069 20.0475 6.86387 19.9126 6.67713C18.0733 4.13462 15.2135 2.5 12.0039 2.5C8.79423 2.5 5.93421 4.13456 4.09516 6.67713H4.09527ZM5.02003 6.92124C6.7053 4.78555 9.20999 3.43034 12.0041 3.43034C14.7982 3.43034 17.3027 4.78553 18.9881 6.92124C17.2949 8.54798 14.7914 9.56973 12.0041 9.56973C9.21676 9.56973 6.7133 8.54796 5.02003 6.92124Z",
    fill: "#979797",
    stroke: "#979797",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4328 22.0726V2.92736C12.4328 2.69145 12.2414 2.5 12.0055 2.5C11.7696 2.5 11.5781 2.69145 11.5781 2.92736V22.0726C11.5781 22.3085 11.7696 22.4999 12.0055 22.4999C12.2414 22.4999 12.4328 22.3085 12.4328 22.0726Z",
    fill: "#979797",
    stroke: "#979797",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.b0e26ffe344357d169664525ea091301.svg";
export { ForwardRef as ReactComponent };